import React from 'react';
import './style.css';

const Banner3 = () => {
  return <div className="banner3-container"></div>;
};

export default Banner3;
